var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Input, ValidationButton } from "@irati/ui/src/FormItem";
import authentication from "@irati/auth";
import Validation from "@irati/utils/validation";
import { H3 } from "@irati/ui/src/Headings";
import Card from "@irati/ui/src/Layout/Card";
import { Para } from "@irati/ui/src/Labels";
import media, { minWidthMedia } from "@irati/ui/src/global/media";
import padding from "@irati/ui/src/global/padding";
import { importChiliPiper } from "../../helpers/loadChiliPiper";
var BannerCTACard = styled(Card)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: ", " auto;\n  border-radius: 15px;\n  ", "\n  ", "\n"], ["\n  margin: ", " auto;\n  border-radius: 15px;\n  ",
    "\n  ",
    "\n"])), padding.base, minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 360px;\n    margin: 0\n  "], ["\n    max-width: 360px;\n    margin: 0\n  "]))), media.phone(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 85%;\n    margin: 30px auto;\n  "], ["\n    width: 85%;\n    margin: 30px auto;\n  "]))));
var BannerCTAHeading = styled(H3)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: left;\n  padding-bottom: 0;\n  ", "\n"], ["\n  text-align: left;\n  padding-bottom: 0;\n  ",
    "\n"])), minWidthMedia.desktop(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: 200px;\n  "], ["\n    max-width: 200px;\n  "]))));
var BannerCTAPara = styled(Para)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var StyledInput = styled(Input)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 15px;\n  .col-xs-12 {\n    padding: 0;\n  }\n"], ["\n  width: 100%;\n  margin-top: 15px;\n  .col-xs-12 {\n    padding: 0;\n  }\n"])));
var StyledValidationButton = styled(ValidationButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-top: 30px;\n"], ["\n  margin-top: 30px;\n"])));
var Hr = styled.hr(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Callback = /** @class */ (function (_super) {
    __extends(Callback, _super);
    function Callback() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            phone: "",
            disabled: false
        };
        _this.componentDidMount = function () {
            var phone = authentication.user().phone;
            if (phone) {
                _this.setState({ phone: phone });
            }
        };
        _this.updatePhone = function (phone) { return _this.setState({ phone: phone }); };
        _this.phoneValidation = function () {
            var msgInvalid = "medical.upsellPage.phoneNumber.invalid";
            return Validation.string("medical.upsellPage.phoneNumberr.required")
                .matches(/[0-9()+ ]/, msgInvalid).min(7, msgInvalid).max(15, msgInvalid);
        };
        _this.handleOnClick = function () {
            var formatMessage = _this.props.formatMessage;
            var phone = _this.state.phone;
            var _a = authentication.user(), firstname = _a.firstname, lastname = _a.lastname, email = _a.email;
            var public_name = authentication.userTenant().public_name;
            _this.setState({ disabled: true });
            importChiliPiper().then(function () {
                window.ChiliPiper.submit("perkbox", "uk-medical-cross-sell-router", {
                    title: formatMessage({ id: "medical.upsellPage.callback.chilipiper.title" }),
                    titleStyle: "Lato 22px #3e3d36",
                    onClose: function () { _this.setState({ disabled: false }); },
                    lead: {
                        firstName: firstname,
                        lastName: lastname,
                        email: email,
                        phone: phone,
                        company: public_name
                    }
                });
            });
        };
        return _this;
    }
    Callback.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var _a = this.state, phone = _a.phone, disabled = _a.disabled;
        return (React.createElement(BannerCTACard, null,
            React.createElement(BannerCTAHeading, { base: true },
                React.createElement(FormattedMessage, { id: "medical.upsellPage.callback.header" })),
            React.createElement(BannerCTAPara, { light: true, narrow: true },
                React.createElement(FormattedMessage, { id: "medical.upsellPage.callback.subHeader" })),
            React.createElement(Hr, null),
            React.createElement(StyledInput, { label: formatMessage({ id: "medical.upsellPage.callback.mobile" }), name: "contactNumber", placeholder: formatMessage({ id: "medical.upsellPage.callback.placeholder" }), value: phone, validation: this.phoneValidation(), onChange: this.updatePhone }),
            React.createElement(StyledValidationButton, { full: true, large: true, primary: true, onClick: this.handleOnClick, disabled: disabled },
                React.createElement(FormattedMessage, { id: "medical.upsellPage.callback.buttonText" }))));
    };
    return Callback;
}(PureComponent));
export default injectIntl(Callback);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
